var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWidgetGraph({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 106,
    viewBox: "0 0 89 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 -9L46.3374 35.9962C46.3374 35.9962 84.8516 72.3394 88.3763 75.8006C98.9505 86.1844 106 97.0008 106 106V-9H0Z",
    fill: "#00FF3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWidgetGraph);
export default __webpack_public_path__ + "static/media/widget-graph.92435257dcb8e149018ffb73edb1d5c2.svg";
export { ForwardRef as ReactComponent };